export default __webpack_public_path__ + "9af8e61f1b93702a1edd3e700e73f5a3.woff2?proxy=wpt-abc";